import {
  GET_ASSIGN_SPECIALIST_LIST,
  GET_ASSIGN_SPECIALIST_LIST_FAILURE,
  GET_ASSIGN_SPECIALIST_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAssignSpecialistListProviderReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GET_ASSIGN_SPECIALIST_LIST:
      return { ...state, loading: true };
    case GET_ASSIGN_SPECIALIST_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_ASSIGN_SPECIALIST_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAssignSpecialistListProviderReducer;
